import OpticksButton from "@/components/ui/OpticksButton/OpticksButton";
import BrandOAuthIcon from "@/components/ui/OpticksIcons/BrandOAuthIcon";
import { useNotificationStore } from "@/zustand/notificationsStore";
import { BASE_URL } from "@/utilities/configurations";
import storageService from "@/services/middleware/storageService";
import OpticksMessage from "@/components/ui/OpticksMessage/OpticksMessage";
import "./LinkAccountStep.css";

interface Props {
  channelDisplayName: string;
  oauthPlatformKey: string;
  linkingPath: string;
  isLinked: boolean;
}

const LinkAccountStep = ({
  channelDisplayName,
  oauthPlatformKey,
  linkingPath,
  isLinked,
}: Props) => {
  const { info } = useNotificationStore((state) => state);

  const handleLinkAccount = () => {
    info(`Redirecting to ${channelDisplayName} OAuth...`);
    const token = storageService.getItem("token");
    const redirectUri = `${window.location.origin}${linkingPath}?flow=oauth`;
    window.open(`${BASE_URL}/platform/${oauthPlatformKey}/link?authorization=${encodeURIComponent(token)}&redirect_uri=${encodeURIComponent(redirectUri)}`, "_blank");
  };

  if (isLinked) {
    return (
      <div className="link-account-step">
        <OpticksMessage type="success">
          <span>
            Your {channelDisplayName} account has been linked successfully.
          </span>
        </OpticksMessage>
      </div>
    );
  }

  return (
    <div className="link-account-step">
      <p>
        Click the button below to link your {channelDisplayName} Ads account and
        let Opticks list the available pixels:
      </p>
      <OpticksButton
        label="Link account"
        icon={<BrandOAuthIcon size={16} />}
        onClick={handleLinkAccount}
      />
    </div>
  );
};

export default LinkAccountStep;
